import LogoHOP from '@/shared/icons/LogoHOP'
import ApplicationCountry from '@/hoc/SidebarMenu/ApplicationCountry'
import { logoOverrides } from '@/hoc/SidebarMenu/styled-components'

interface SidebarMenuBrandProps {
  country: string
}

const SidebarMenuBrand = ({ country }: SidebarMenuBrandProps) => (
  <>
    <LogoHOP title={undefined} overrides={logoOverrides()} />
    <ApplicationCountry country={country} />
  </>
)

export default SidebarMenuBrand
